export default __webpack_public_path__ + "assets/webgl/matcap_red_plastic.fd128404.jpg";